import Vue from 'vue'

export const EMAIL_SERVICE = "service_npkc0xp"
export const EMAIL_TEMPLATE = "template_co9dypt"
export const EMAIL_USER_ID = "user_RfXhSuOytzQzSfEZTDa27"

export function showSuccess(e) {
    if (!e) {
        Vue.toasted.global.defaultSuccess({})
    } else if (e && e.response && e.response.data) {
        Vue.toasted.global.defaultSuccess({ msg: e.response.data })
    } else if (typeof e === 'string') {
        Vue.toasted.global.defaultSuccess({ msg: e })
    } else if (e.message) {
        Vue.toasted.global.defaultSuccess({ msg: e.message })
    } else if (e.length > 0) {
        e.forEach((e) = this.Vue.toasted.global.defaultSuccess(e.message))
    }
}

export function showError(e) {
    if (e && e.response && e.response.data) {
        Vue.toasted.global.defaultError({ msg: e.response.data })

    } else if (typeof e === 'string') {
        Vue.toasted.global.defaultError({ msg: e })
    } else if (e.message) {
        Vue.toasted.global.defaultError({ msg: e.message })
    } else if (e.length > 0) {
        e.forEach((e) = this.Vue.toasted.global.defaultError(e.message))
    } else {
        Vue.toasted.global.defaultError({})
    }
}

export function scrollTop() {
    window.scrollTo(0, 0);
}